import { ChatMessageModel, ChatModel } from '../../../../api-service/clients';
import { formatDateTime } from '../../../../utilities/date-helper';

const excerptLength = 150;
const excerptUpToEndOfWord = new RegExp(`^.{${excerptLength}}\\S*`, 'u');
const newChatAgeInMs = 5 * 60 * 1000;

export function citizenText(chat: ChatModel): string {
  return chat.citizen?.name ?? '';
}

export function participantsText(chat: ChatModel): string {
  const names = [
    chat.caseworker?.name,
    ...(chat.contacts ?? []).map(contact => contact.name && (contact.role ? `${contact.name} (${contact.role})` : contact.name)),
    ...(chat.secondaryCaseworkers ?? []).map(caseworker => caseworker.name && `${caseworker.name} (Sekundær sagsbehandler)`),
  ];
  return names.filter((name): name is string => !!name).join(', ');
}

export function latestMessageText(chat: ChatModel): string {
  if (chat.isConfidential && !chat.isPartOf) {
    return 'Fortrolig';
  }
  const message = latestMessageOf(chat);
  if (!message) {
    return '';
  }
  return `${formatDateTime(message.creationDate)} ${authorNameOf(chat, message.writerUserId)}: ${excerptOf(message)}`;
}

export function hasUnreadLatestMessage(chat: ChatModel): boolean {
  const message = latestMessageOf(chat);
  return !!message && chat.isPartOf && !(message.seenByUserIds ?? []).includes(chat.currentUserId);
}

export function isNewChat(chat: ChatModel, now: Date): boolean {
  return now.getTime() - new Date(chat.creationDate).getTime() < newChatAgeInMs;
}

function latestMessageOf(chat: ChatModel): ChatMessageModel | undefined {
  return [...(chat.chatMessages ?? [])].sort((first, second) => new Date(second.creationDate).getTime() - new Date(first.creationDate).getTime())[0];
}

function authorNameOf(chat: ChatModel, writerUserId: string): string {
  const people = [chat.citizen, chat.caseworker, ...(chat.secondaryCaseworkers ?? [])];
  const person = people.find(candidate => candidate?.id === writerUserId);
  const contact = (chat.contacts ?? []).find(candidate => candidate.id === writerUserId || candidate.externalId === writerUserId);
  return person?.name ?? contact?.name ?? 'Ukendt';
}

function excerptOf(message: ChatMessageModel): string {
  if (!message.content) {
    return message.attachmentMetaData ? 'Har sendt en vedhæftet fil' : '';
  }
  const oneLine = message.content.replace(/\s+/g, ' ');
  const excerpt = oneLine.match(excerptUpToEndOfWord)?.[0] ?? oneLine;
  return excerpt.length < oneLine.length ? `${excerpt}...` : excerpt;
}
